export default "__VITE_ASSET__DHUnmTxO__"